import React from 'react'
import { TextMediumSM } from '../../../../../Components/Text/MediumText'
import StatusSuppTickets from './Status'
import DivisionSuppTickets from './Division'
import PriorityuppTickets from './Priority'
import TicketType from './TicketType'
import CategorySuppTickets from './Category'
import { Ticket } from 'lucide-react'
import { HeadingWithIcon } from '../../../../../Components/Utils/Settingheading'

function SupportTicketsSettings() {
    return(
        <>
                     <HeadingWithIcon icon={Ticket} title="Tickets" />

        <div className='w-full flex flex-wrap justify-center md:justify-start  items-center overflow-y-scroll'>
        
        <div className=' w-full md:w-1/2 lg:w-1/3 mt-4'>
            <CategorySuppTickets/>
         </div>
        <div className=' w-full md:w-1/2 lg:w-1/3 mt-4'>
            <DivisionSuppTickets/>
         </div>
         {/* <div className=' w-full md:w-1/2 lg:w-1/3 mt-4'>
            <PriorityuppTickets/>
         </div> */}
         <div className=' w-full md:w-1/2 lg:w-1/3 mt-4'>
            <TicketType/>
         </div>
         <div className=' w-full md:w-1/2 lg:w-1/3 mt-4'>
            <StatusSuppTickets/>
         </div>
        
       
         </div>
         </>
    )
}

export default SupportTicketsSettings
